import { IItemsStyle, ItemSeparatorKinds } from "./IItemsStyle";

export class ItemsStyle {
  constructor(
    public separator: ItemSeparatorKinds,
  ) {
  }
  
  clone(): ItemsStyle {
    return new ItemsStyle(this.separator);
  }

  static from(source: IItemsStyle): ItemsStyle {
    return new ItemsStyle(source.separator);
  }

  static to(source: ItemsStyle): IItemsStyle {
    return {
      separator: source.separator,
    };
  }
}
